import React from 'react';
import { makeStyles } from '@mui/styles';
import Link from 'next/link';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const sharedStyle = {
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 1.12,
  textDecoration: 'none',
  textTransform: 'uppercase',
};

export const linkStyle = {
  // color: '#ffffff',
  color: '#0f326c',
  ...sharedStyle,

  '&:hover': {
    color: '#bfc5d2',
  },
  '&:active': {
    color: '#3967b2',
  },
};

const useStyles = makeStyles(theme => ({
  light: { ...linkStyle, color: '#ffffff' },

  dark: linkStyle,
}));

const DoxerLink = ({ href, children, variant, className }) => {
  const classes = useStyles();
  const baseClass = variant === 'light' ? classes.light : classes.dark;

  // if external link then use a tag instead of next/link
  if (href.startsWith('http')) {
    return (
      <a href={href} className={clsx(baseClass, className)}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href} legacyBehavior>
      <a href={'#'} className={clsx(baseClass, className)}>
        {children}
      </a>
    </Link>
  );
};

DoxerLink.propTypes = {
  variant: PropTypes.oneOf(['light', 'dark']),
};

DoxerLink.defaultProps = {
  variant: 'light',
};

export default DoxerLink;
